module.exports = __webpack_public_path__ + "img/img_throw_4@2x_v3.620f5dfd.png";